import genericAction from "@Actions/generic";
import { isEmpty } from "lodash";

const dataHandler = async ({ dispatch, url, params, method = "GET", withLoading = true }) => {
	const urlParams = new URLSearchParams(params).toString();

	const data = await dispatch(genericAction({ method, route: `${url}?${urlParams}`, withLoading }));
	if (isEmpty(data)) return [];
	return data;
};

export default dataHandler;
